import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function SNTreatmentGoalSelect(props) {
	const { schema, formData, onChange, required } = props;
	const { title } = schema;

	const {
		S2$G2,
		F231,
		F459
	} = useSelector(state => state.form.formData);

	let clientStatedGoals = F231 || [];
	let goalsAfterAssessment = F459 || [];

	const [data, setData] = useState(formData || {});
	const [goals, setGoals] = useState(_.get(S2$G2, 'F91', []));

	useEffect(() => {
		let items = [];

		_.each(goals, (goal, i) => {
			let objectives = []
		
			if(i < clientStatedGoals.length) {
				objectives = clientStatedGoals[i]['objectives'] || []
			}
			
			items.push({
				therapy: goal.therapy,
				objectives
			})
		})

		items = [...items, ...goalsAfterAssessment]

		setGoals(items);
	}, []);

	useEffect(() => {
		let timer = setTimeout(() => {
			onChange(data)
		});

		return (() => {
			clearTimeout(timer);
		})
	}, [JSON.stringify(data)]);

	function handleGoalChange(isChecked, value) {
		let item = { ...data };

		if (!isChecked) {
			item = _.omit(item, value)
		} else {
			item = {
				...data,
				[value]: []
			}
		}

		setData(item);
	}

	function handleObjectiveChange(isChecked, parent, value) {
		let items = { ...data };

		if (!items[parent]) {
			items[parent] = [];
		}

		let objectives = [...items[parent]];

		if (!isChecked) {
			items[parent] = _.filter(objectives, function (v) {
				return v !== value;
			});
		} else {
			items[parent] = [...items[parent], value];
		}

		onChange(items);
	}

	return (
		<React.Fragment>
			<label>{title}{required && "*"}</label>

			{
				!_.isEmpty(goals) &&
				<ul className="sn-t-goal-objective" style={{ listStyle: "none", paddingLeft: "20px" }}>
					{
						goals.map((goal, i) => (
							<li key={`goal-${i}`}>
								<label>
									<input
										id={`goal-input-${i}`}
										type="checkbox"
										onChange={(e) => handleGoalChange(e.target.checked, goal.therapy)}
										checked={_.hasIn(formData, goal.therapy)}
									/> {goal.therapy}
								</label>
								<ul style={{ listStyle: "none", paddingLeft: "20px" }}>
									{
										_.hasIn(goal, 'objectives') && goal.objectives.map((obj, j) => {
											let key = `obj-${i}-${j}`;

											return (
												<li key={key}>
													<label>
														<input
															type="checkbox"
															onChange={(e) => {
																handleObjectiveChange(e.target.checked, goal.therapy, obj);
															}}
															checked={_.hasIn(formData, goal.therapy) && _.includes(formData[goal.therapy], obj)}
														/> {obj}
													</label>
												</li>
											)
										})
									}
								</ul>
							</li>
						))
					}
				</ul>
			}
		</React.Fragment>
	)
}

export default SNTreatmentGoalSelect;